// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../styles/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./map-object-popup.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./routes-modal.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Home/Map page styles
 * These styles are scoped to .home-shell to avoid affecting other pages.
 * The map requires fixed viewport with no scrolling - the map tiles handle pan/zoom.
 */

.home-shell {
  /* Lock the viewport for map - no document scrolling */
  position: fixed;
  inset: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: var(--cfn-bg-primary);
  color: var(--cfn-text-secondary);
}

/* Dark theme gradient background for map */
.theme-dark .home-shell,
:root:not(.theme-light) .home-shell {
  background: radial-gradient(circle at top, #0f172a, #020617 65%);
}

/* Light theme solid background for map */
.theme-light .home-shell {
  background: var(--cfn-bg-primary);
}

.home-shell__main {
  flex: 1;
  padding: 0;
  padding-top: 72px; /* leave space for the fixed nav */
}

.home-map-frame {
  position: relative;
  width: 100%;
  height: calc(100vh - 72px);
  height: calc(var(--app-height, 100dvh) - 72px); /* --app-height set by useOrientationResize; dvh fallback */
  background: var(--cfn-bg-primary);
}

.home-map-frame__canvas {
  position: absolute;
  inset: 0;
  z-index: 1; /* Ensure map is below navigation */
}

.home-map-frame__canvas .leaflet-container {
  z-index: 1;
}

.home-map-frame__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  background: var(--cfn-bg-overlay);
  text-align: center;
  padding: 2rem;
}

.home-map-frame__spinner {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 4px solid var(--cfn-spinner-track);
  border-top-color: var(--cfn-spinner-fill);
  animation: home-spin 1s linear infinite;
}

#piaMaps {
  width: 100%;
  height: 100%;
}

/* Theme toggle positioning */
.home-map-frame__theme-toggle {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
}

/* Route info panel positioning */
.home-map-frame__route-info {
  position: absolute;
  bottom: 30px;
  left: 10px;
  z-index: 1000;
  pointer-events: auto;
}

@keyframes home-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 960px) {
  .home-shell__main {
    padding-top: 64px;
  }

  .home-map-frame {
    height: calc(100vh - 64px);
    height: calc(var(--app-height, 100dvh) - 64px);
  }

  .home-map-frame__canvas {
    position: absolute;
    inset: 0;
  }
}

.home-map-frame .leaflet-popup-content-wrapper {
  background: var(--cfn-popup-bg);
  border-radius: 20px;
  border: 1px solid var(--cfn-popup-border);
  box-shadow: var(--cfn-popup-shadow);
  color: var(--cfn-text-primary);
}

.home-map-frame .leaflet-popup-tip {
  background: var(--cfn-popup-bg);
}

.home-map-frame .leaflet-popup-content {
  margin: 0;
  padding: 0;
  /* Keep popups within the viewport (notably short landscape) and scroll if tall.
     120px ≈ nav (≤72px) + popup tip + padding + margin headroom. --app-height is
     inherited from <html> (set by useOrientationResize); --cfn-nav-height is not
     in scope on the Leaflet popup, so it is not used here. */
  max-height: calc(var(--app-height, 100dvh) - 120px);
  overflow-y: auto;
}

.cfn-crosshair-popup {
  padding: 1rem 1.25rem 1.15rem;
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--cfn-text-primary);
  min-width: 260px;
  width: min(357px, calc(100vw - 32px));
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cfn-crosshair-popup__title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.cfn-crosshair-popup__title a {
  color: var(--cfn-info);
}

.cfn-crosshair-popup__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.4rem 0 0.1rem;
  border-bottom: 1px solid var(--cfn-border-muted);
  overflow: visible;
  white-space: normal;
}

.cfn-crosshair-popup__actions label {
  padding-left: 0;
  background: var(--cfn-bg-tertiary);
  border-radius: 12px;
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--cfn-text-primary);
}

.cfn-crosshair-popup__actions label i {
  font-size: 1rem;
}

.cfn-crosshair-popup__grid {
  display: grid;
  grid-template-columns: minmax(0, 120px) minmax(0, 1fr);
  -moz-column-gap: 0.65rem;
       column-gap: 0.65rem;
  row-gap: 0.35rem;
  margin: 0;
}

.cfn-crosshair-popup__grid dt {
  color: var(--cfn-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 0.65rem;
  margin: 0;
}

.cfn-crosshair-popup__grid dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--cfn-text-primary);
}

.cfn-crosshair-popup__grid dd a {
  color: var(--cfn-info);
}

.cfn-crosshair-popup__cta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  border-top: 1px solid var(--cfn-border-muted);
  padding-top: 0.65rem;
  margin-top: 0.15rem;
}

.cfn-crosshair-popup__button {
  flex: 1 1 140px;
  margin: 0;
  text-align: center;
}

.cfn-crosshair-popup__cta-icon {
  background: var(--cfn-info-muted);
  border-radius: 12px;
  padding: 0.45rem 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.home-map-frame .btn-pia-primary {
  background: var(--cfn-btn-primary-bg);
  border: none;
  color: var(--cfn-btn-primary-text);
}

.home-map-frame .btn-pia-secondary {
  background: var(--cfn-btn-secondary-bg);
  border: 1px solid var(--cfn-btn-secondary-border);
  color: var(--cfn-btn-secondary-text);
}

.home-map-frame .btn-pia-secondary:hover {
  background: var(--cfn-btn-secondary-hover-bg);
}

/* Legacy modal overrides */
body.modal-open {
  overflow: hidden;
}

.modal {
  position: fixed;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: var(--cfn-bg-overlay);
  z-index: 1000;
  color: var(--cfn-text-secondary);
  overflow-y: auto;
}

.modal.show {
  display: flex;
}

.modal.fade {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.modal.fade.show {
  opacity: 1;
}

.modal-dialog {
  width: min(640px, 100%);
  max-width: 100%;
  margin: auto;
}

.modal-dialog.modal-lg {
  width: min(960px, 100%);
}

.modal-content {
  background: var(--cfn-modal-bg);
  border-radius: 16px;
  border: 1px solid var(--cfn-border);
  box-shadow: var(--cfn-modal-shadow);
  width: 100%;
  color: var(--cfn-text-secondary);
}

.modal-header,
.modal-body,
.modal-footer {
  padding: 1.25rem 1.5rem;
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-bottom: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-header-bg);
}

.modal-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: var(--cfn-text-primary);
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  color: var(--cfn-text-secondary);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  border-top: 1px solid var(--cfn-border-muted);
  background: var(--cfn-modal-footer-bg);
}

.close {
  border: none;
  background: transparent;
  color: var(--cfn-text-muted);
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  margin-left: auto;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  border-radius: 0.5rem;
  border: 1px solid transparent;
  padding: 0.45rem 1rem;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.btn-primary {
  background: var(--cfn-btn-primary-bg);
  border-color: var(--cfn-btn-primary-border);
  color: var(--cfn-btn-primary-text);
}

.btn-secondary {
  background: var(--cfn-btn-secondary-bg);
  border-color: var(--cfn-btn-secondary-border);
  color: var(--cfn-btn-secondary-text);
}

.btn-danger {
  background: var(--cfn-btn-danger-bg);
  border-color: var(--cfn-btn-danger-border);
  color: var(--cfn-btn-danger-text);
}

.btn:disabled,
.btn.disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.85rem;
}

.form-control {
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid var(--cfn-input-border);
  background: var(--cfn-input-bg);
  color: var(--cfn-input-text);
  padding: 0.5rem 0.75rem;
  font-size: 0.95rem;
}

.form-control:focus {
  outline: none;
  border-color: var(--cfn-input-focus-border);
  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);
}

.form-control::-moz-placeholder {
  color: var(--cfn-input-placeholder);
}

.form-control::placeholder {
  color: var(--cfn-input-placeholder);
}

.control-label {
  font-size: 0.9rem;
  color: var(--cfn-text-secondary);
  font-weight: 600;
}

.custom-control {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.85rem;
  color: var(--cfn-text-secondary);
}

.custom-control-input {
  width: 1rem;
  height: 1rem;
}

.custom-control-label {
  cursor: pointer;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  color: var(--cfn-text-secondary);
}

.table th,
.table td {
  border-bottom: 1px solid var(--cfn-table-border);
  padding: 0.5rem 0.4rem;
  text-align: left;
}

.table th {
  font-weight: 600;
  color: var(--cfn-text-primary);
  background: var(--cfn-table-header-bg);
}

.table tr:hover {
  background: var(--cfn-table-row-hover);
}

.msg-error {
  color: var(--cfn-danger-text);
  font-size: 0.8rem;
  margin-top: 0.2rem;
}

.modal hr {
  border: none;
  border-bottom: 1px solid var(--cfn-border-muted);
  margin: 1rem 0;
}

/* Fix spacing for Leaflet icon-only buttons */
.leaflet-bar a,
.easy-button-button {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 8px !important;
  min-width: 34px !important;
  min-height: 34px !important;
}

.leaflet-bar a .button-state,
.easy-button-button .button-state {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.leaflet-control-zoom a,
.leaflet-bar a {
  line-height: 1 !important;
}

/* Crosshair button specific fix */
.leaflet-control-crosshairs {
  padding: 4px !important;
}

.leaflet-control-crosshairs a {
  padding: 6px !important;
}

/* Tailwind responsiveness fallback for home SPA */
@media (min-width: 768px) {
  .home-shell .md\\:flex {
    display: flex !important;
  }

  .home-shell .md\\:block {
    display: block !important;
  }
}

/* Short landscape: nav is slimmed to 48px, so reclaim the map offset to match */
@media (orientation: landscape) and (max-height: 600px) {
  .home-shell__main {
    padding-top: 48px;
  }

  .home-map-frame {
    height: calc(100vh - 48px);
    height: calc(var(--app-height, 100dvh) - 48px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/home/styles/home.css"],"names":[],"mappings":"AAIA;;;;EAIE;;AAEF;EACE,sDAAsD;EACtD,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yGAAyG;EACzG,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,2CAA2C;AAC3C;;EAEE,gEAAgE;AAClE;;AAEA,yCAAyC;AACzC;EACE,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,UAAU;EACV,iBAAiB,EAAE,kCAAkC;AACvD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0BAA0B;EAC1B,8CAA8C,EAAE,2DAA2D;EAC3G,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU,EAAE,mCAAmC;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,8CAA8C;EAChD;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,UAAU;EACV;;;6DAG2D;EAC3D,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,yGAAyG;EACzG,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,gDAAgD;EAChD,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,wBAAmB;OAAnB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,6CAA6C;EAC7C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,WAAW;EACX,gCAAgC;AAClC;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;AACrC;;AAFA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,gDAAgD;EAChD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gDAAgD;EAChD,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,8CAA8C;EAChD;AACF","sourcesContent":["@import '../../../styles/theme.css';\n@import './map-object-popup.css';\n@import './routes-modal.css';\n\n/*\n * Home/Map page styles\n * These styles are scoped to .home-shell to avoid affecting other pages.\n * The map requires fixed viewport with no scrolling - the map tiles handle pan/zoom.\n */\n\n.home-shell {\n  /* Lock the viewport for map - no document scrolling */\n  position: fixed;\n  inset: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  background: var(--cfn-bg-primary);\n  color: var(--cfn-text-secondary);\n}\n\n/* Dark theme gradient background for map */\n.theme-dark .home-shell,\n:root:not(.theme-light) .home-shell {\n  background: radial-gradient(circle at top, #0f172a, #020617 65%);\n}\n\n/* Light theme solid background for map */\n.theme-light .home-shell {\n  background: var(--cfn-bg-primary);\n}\n\n.home-shell__main {\n  flex: 1;\n  padding: 0;\n  padding-top: 72px; /* leave space for the fixed nav */\n}\n\n.home-map-frame {\n  position: relative;\n  width: 100%;\n  height: calc(100vh - 72px);\n  height: calc(var(--app-height, 100dvh) - 72px); /* --app-height set by useOrientationResize; dvh fallback */\n  background: var(--cfn-bg-primary);\n}\n\n.home-map-frame__canvas {\n  position: absolute;\n  inset: 0;\n  z-index: 1; /* Ensure map is below navigation */\n}\n\n.home-map-frame__canvas .leaflet-container {\n  z-index: 1;\n}\n\n.home-map-frame__overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  background: var(--cfn-bg-overlay);\n  text-align: center;\n  padding: 2rem;\n}\n\n.home-map-frame__spinner {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 4px solid var(--cfn-spinner-track);\n  border-top-color: var(--cfn-spinner-fill);\n  animation: home-spin 1s linear infinite;\n}\n\n#piaMaps {\n  width: 100%;\n  height: 100%;\n}\n\n/* Theme toggle positioning */\n.home-map-frame__theme-toggle {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  z-index: 1000;\n}\n\n/* Route info panel positioning */\n.home-map-frame__route-info {\n  position: absolute;\n  bottom: 30px;\n  left: 10px;\n  z-index: 1000;\n  pointer-events: auto;\n}\n\n@keyframes home-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 960px) {\n  .home-shell__main {\n    padding-top: 64px;\n  }\n\n  .home-map-frame {\n    height: calc(100vh - 64px);\n    height: calc(var(--app-height, 100dvh) - 64px);\n  }\n\n  .home-map-frame__canvas {\n    position: absolute;\n    inset: 0;\n  }\n}\n\n.home-map-frame .leaflet-popup-content-wrapper {\n  background: var(--cfn-popup-bg);\n  border-radius: 20px;\n  border: 1px solid var(--cfn-popup-border);\n  box-shadow: var(--cfn-popup-shadow);\n  color: var(--cfn-text-primary);\n}\n\n.home-map-frame .leaflet-popup-tip {\n  background: var(--cfn-popup-bg);\n}\n\n.home-map-frame .leaflet-popup-content {\n  margin: 0;\n  padding: 0;\n  /* Keep popups within the viewport (notably short landscape) and scroll if tall.\n     120px ≈ nav (≤72px) + popup tip + padding + margin headroom. --app-height is\n     inherited from <html> (set by useOrientationResize); --cfn-nav-height is not\n     in scope on the Leaflet popup, so it is not used here. */\n  max-height: calc(var(--app-height, 100dvh) - 120px);\n  overflow-y: auto;\n}\n\n.cfn-crosshair-popup {\n  padding: 1rem 1.25rem 1.15rem;\n  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--cfn-text-primary);\n  min-width: 260px;\n  width: min(357px, calc(100vw - 32px));\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.cfn-crosshair-popup__title {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.cfn-crosshair-popup__title a {\n  color: var(--cfn-info);\n}\n\n.cfn-crosshair-popup__actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.4rem 0 0.1rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  overflow: visible;\n  white-space: normal;\n}\n\n.cfn-crosshair-popup__actions label {\n  padding-left: 0;\n  background: var(--cfn-bg-tertiary);\n  border-radius: 12px;\n  width: 42px;\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--cfn-text-primary);\n}\n\n.cfn-crosshair-popup__actions label i {\n  font-size: 1rem;\n}\n\n.cfn-crosshair-popup__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 120px) minmax(0, 1fr);\n  column-gap: 0.65rem;\n  row-gap: 0.35rem;\n  margin: 0;\n}\n\n.cfn-crosshair-popup__grid dt {\n  color: var(--cfn-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 0.65rem;\n  margin: 0;\n}\n\n.cfn-crosshair-popup__grid dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--cfn-text-primary);\n}\n\n.cfn-crosshair-popup__grid dd a {\n  color: var(--cfn-info);\n}\n\n.cfn-crosshair-popup__cta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  border-top: 1px solid var(--cfn-border-muted);\n  padding-top: 0.65rem;\n  margin-top: 0.15rem;\n}\n\n.cfn-crosshair-popup__button {\n  flex: 1 1 140px;\n  margin: 0;\n  text-align: center;\n}\n\n.cfn-crosshair-popup__cta-icon {\n  background: var(--cfn-info-muted);\n  border-radius: 12px;\n  padding: 0.45rem 0.75rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.home-map-frame .btn-pia-primary {\n  background: var(--cfn-btn-primary-bg);\n  border: none;\n  color: var(--cfn-btn-primary-text);\n}\n\n.home-map-frame .btn-pia-secondary {\n  background: var(--cfn-btn-secondary-bg);\n  border: 1px solid var(--cfn-btn-secondary-border);\n  color: var(--cfn-btn-secondary-text);\n}\n\n.home-map-frame .btn-pia-secondary:hover {\n  background: var(--cfn-btn-secondary-hover-bg);\n}\n\n/* Legacy modal overrides */\nbody.modal-open {\n  overflow: hidden;\n}\n\n.modal {\n  position: fixed;\n  inset: 0;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: var(--cfn-bg-overlay);\n  z-index: 1000;\n  color: var(--cfn-text-secondary);\n  overflow-y: auto;\n}\n\n.modal.show {\n  display: flex;\n}\n\n.modal.fade {\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.modal.fade.show {\n  opacity: 1;\n}\n\n.modal-dialog {\n  width: min(640px, 100%);\n  max-width: 100%;\n  margin: auto;\n}\n\n.modal-dialog.modal-lg {\n  width: min(960px, 100%);\n}\n\n.modal-content {\n  background: var(--cfn-modal-bg);\n  border-radius: 16px;\n  border: 1px solid var(--cfn-border);\n  box-shadow: var(--cfn-modal-shadow);\n  width: 100%;\n  color: var(--cfn-text-secondary);\n}\n\n.modal-header,\n.modal-body,\n.modal-footer {\n  padding: 1.25rem 1.5rem;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-header-bg);\n}\n\n.modal-title {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n  color: var(--cfn-text-primary);\n}\n\n.modal-body {\n  max-height: 70vh;\n  overflow-y: auto;\n  color: var(--cfn-text-secondary);\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  border-top: 1px solid var(--cfn-border-muted);\n  background: var(--cfn-modal-footer-bg);\n}\n\n.close {\n  border: none;\n  background: transparent;\n  color: var(--cfn-text-muted);\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  border-radius: 0.5rem;\n  border: 1px solid transparent;\n  padding: 0.45rem 1rem;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.btn-primary {\n  background: var(--cfn-btn-primary-bg);\n  border-color: var(--cfn-btn-primary-border);\n  color: var(--cfn-btn-primary-text);\n}\n\n.btn-secondary {\n  background: var(--cfn-btn-secondary-bg);\n  border-color: var(--cfn-btn-secondary-border);\n  color: var(--cfn-btn-secondary-text);\n}\n\n.btn-danger {\n  background: var(--cfn-btn-danger-bg);\n  border-color: var(--cfn-btn-danger-border);\n  color: var(--cfn-btn-danger-text);\n}\n\n.btn:disabled,\n.btn.disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.85rem;\n}\n\n.form-control {\n  width: 100%;\n  border-radius: 0.5rem;\n  border: 1px solid var(--cfn-input-border);\n  background: var(--cfn-input-bg);\n  color: var(--cfn-input-text);\n  padding: 0.5rem 0.75rem;\n  font-size: 0.95rem;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: var(--cfn-input-focus-border);\n  box-shadow: 0 0 0 3px var(--cfn-input-focus-ring);\n}\n\n.form-control::placeholder {\n  color: var(--cfn-input-placeholder);\n}\n\n.control-label {\n  font-size: 0.9rem;\n  color: var(--cfn-text-secondary);\n  font-weight: 600;\n}\n\n.custom-control {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  color: var(--cfn-text-secondary);\n}\n\n.custom-control-input {\n  width: 1rem;\n  height: 1rem;\n}\n\n.custom-control-label {\n  cursor: pointer;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n  color: var(--cfn-text-secondary);\n}\n\n.table th,\n.table td {\n  border-bottom: 1px solid var(--cfn-table-border);\n  padding: 0.5rem 0.4rem;\n  text-align: left;\n}\n\n.table th {\n  font-weight: 600;\n  color: var(--cfn-text-primary);\n  background: var(--cfn-table-header-bg);\n}\n\n.table tr:hover {\n  background: var(--cfn-table-row-hover);\n}\n\n.msg-error {\n  color: var(--cfn-danger-text);\n  font-size: 0.8rem;\n  margin-top: 0.2rem;\n}\n\n.modal hr {\n  border: none;\n  border-bottom: 1px solid var(--cfn-border-muted);\n  margin: 1rem 0;\n}\n\n/* Fix spacing for Leaflet icon-only buttons */\n.leaflet-bar a,\n.easy-button-button {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 8px !important;\n  min-width: 34px !important;\n  min-height: 34px !important;\n}\n\n.leaflet-bar a .button-state,\n.easy-button-button .button-state {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.leaflet-control-zoom a,\n.leaflet-bar a {\n  line-height: 1 !important;\n}\n\n/* Crosshair button specific fix */\n.leaflet-control-crosshairs {\n  padding: 4px !important;\n}\n\n.leaflet-control-crosshairs a {\n  padding: 6px !important;\n}\n\n/* Tailwind responsiveness fallback for home SPA */\n@media (min-width: 768px) {\n  .home-shell .md\\:flex {\n    display: flex !important;\n  }\n\n  .home-shell .md\\:block {\n    display: block !important;\n  }\n}\n\n/* Short landscape: nav is slimmed to 48px, so reclaim the map offset to match */\n@media (orientation: landscape) and (max-height: 600px) {\n  .home-shell__main {\n    padding-top: 48px;\n  }\n\n  .home-map-frame {\n    height: calc(100vh - 48px);\n    height: calc(var(--app-height, 100dvh) - 48px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
